import React, { useCallback, useContext, useEffect, useState } from "react";
import Heading from "../../core/Heading";
import CustomCKEditor from "../../CustomCKEditor";
import TextModal from "../modals/TextModal";
import { FaInfoCircle } from "react-icons/fa";
import CommentModal from "../modals/CommentModal";
import { useUpdateCCDataMutation } from "modules/pvs_activities/redux/service/dForm";
import { debounce } from "lodash";
import { FormDataContext } from "../../contexts/FormContext";
import { displayNotification } from "helpers";
import { defaultSingleCCDataTemplate } from "modules/pvs_activities/constants";

const DynamicCCFindings = (props) => {
    const formDataContext = useContext(FormDataContext);

    const [data, setData] = useState({ ...defaultSingleCCDataTemplate });
    const [updateCCData, updateCCDataRes] = useUpdateCCDataMutation();

    useEffect(() => {
        setData({ ...defaultSingleCCDataTemplate, ...props.value });
    }, [props.value]);

    useEffect(() => {
        if (updateCCDataRes.isError) {
            displayNotification("error", "Error saving Critical Competency Findings data.");
            console.log({ error: updateCCDataRes.error });
        }
    }, [updateCCDataRes]);

    const handleOnChange = (val) => {
        const tmp = { ...data, content: val };
        setData(tmp);
        if (formDataContext.mode === "data_entry") {
            updateValueToDB(tmp);
        }
    };

    const updateValueToDB = useCallback(
        debounce((obj) => {
            updateCCData({
                template_id: formDataContext.templateId,
                section_id: formDataContext.sectionId,
                element_id: props.elementId,
                movement_id: formDataContext.movementId,
                cc_id: props.ccId,
                key: "findings",
                ...obj,
            });
        }, 1000),
        [props.handleOnChange]
    );

    return (
        <>
            <div className="d-flex align-items-center mb-3">
                <Heading size="h6" font="Sohne-Buch" label="Findings:" />
                <div className="ms-auto">
                    <TextModal
                        title="Instructions"
                        icon={<FaInfoCircle />}
                        content={""}
                        className="me-2"
                        size="small"
                    />
                    <CommentModal elementId={props.elementId} ccId={props.ccId} />
                </div>
            </div>
            <CustomCKEditor height={200} value={data.content} onChange={handleOnChange} disabled={props.disabled} />
        </>
    );
};

DynamicCCFindings.defaultProps = {
    ccId: "",
    value: "",
    onChange: () => {},
    disabled: true,
    elementId: "",
};

export default DynamicCCFindings;
